<script lang="ts">
	import { DEFAULT_FEATURE_COLOR } from '#lib/vizPalette.js';
	import { attributesColumns } from '../layerConfig';
	import { resolveFeatureSwatch } from '#lib/components/map/legend/symbology.js';
	import { RLGSP_SPRITE_PATH } from '../loadMapSprites';
	import FeatureAttributesPanel from '#lib/components/FeatureAttributesPanel.svelte';
	import SymbologySwatch from '#lib/components/map/legend/SymbologySwatch.svelte';
</script>

<FeatureAttributesPanel columns={attributesColumns} showLayerName>
	{#snippet icon(feature)}
		<SymbologySwatch
			swatch={resolveFeatureSwatch(feature.layer) ?? {
				kind: 'circle',
				color: DEFAULT_FEATURE_COLOR
			}}
			spritePath={RLGSP_SPRITE_PATH} />
	{/snippet}
</FeatureAttributesPanel>
